import { Box, Stack } from '@mui/material';
import type { ReactNode } from 'react';
import { designTokens } from '../tokens';
import { pageContentFrame, type PageContentWidth } from './pageContent';

export type PageActionBarProps = {
  children: ReactNode;
  width?: PageContentWidth;
};

/**
 * 조회 문서의 하단 action 영역입니다. page content와 같은 폭·gutter를 사용하며,
 * 업무별 안내와 button은 children으로 받습니다. 편집 저장·취소는 EditPage를 사용합니다.
 */
export function PageActionBar({ children, width = 'standard' }: PageActionBarProps) {
  return <Box
    data-testid="page-action-bar"
    sx={{ flexShrink: 0, borderTop: 1, borderColor: 'divider', bgcolor: designTokens.color.canvas }}
  >
    <Stack
      direction="row"
      spacing={1}
      useFlexGap
      sx={{
        ...pageContentFrame(width),
        minHeight: 64,
        py: `${designTokens.layout.surfaceActionBlockPadding}px`,
        boxSizing: 'border-box',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
      }}
    >
      {children}
    </Stack>
  </Box>;
}
